import { useAssetContext, useUserContext } from "@dexteel/mesf-core";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTaskListContext } from "../context/taskListContext";

export const useInitializeTaskList = () => {
	const {
		state: { defaultAreaId },
	} = useUserContext();

	const {
		state: { allAssets },
	} = useAssetContext();

	const navigate = useNavigate();
	const [filtersLoaded, setFiltersLoaded] = useState(false);

	const { actions } = useTaskListContext();

	const params = useParams();

	useEffect(() => {
		if (allAssets && allAssets.length) {
			actions.setallAssets(allAssets);
			setFiltersLoaded(true);
		}
	}, [allAssets]);

	useEffect(() => {
		if (filtersLoaded) {
			if (params.AssetIdParam) {
				actions.setAssetSearchId(params.AssetIdParam);
			} else if (defaultAreaId !== null && defaultAreaId !== undefined) {
				// Initialize with defaultAreaId if no AssetIdParam (only on initial load)
				actions.setAssetSearchId(defaultAreaId);
			}
		}
	}, [JSON.stringify(params), filtersLoaded]);
};
